//mutationobserver-shim v0.3.2 (github.com/megawac/MutationObserver.js)
//Authors: Graeme Yeates (github.com/megawac)
window.MutationObserver =
	window.MutationObserver ||
	(function (w) {
		function v(a) {
			this.i = [];
			this.m = a;
		}
		function I(a) {
			(function c() {
				var d = a.takeRecords();
				d.length && a.m(d, a);
				a.h = setTimeout(c, v._period);
			})();
		}
		function p(a) {
			var b = { type: null, target: null, addedNodes: [], removedNodes: [], previousSibling: null, nextSibling: null, attributeName: null, attributeNamespace: null, oldValue: null },
				c;
			for (c in a) b[c] !== w && a[c] !== w && (b[c] = a[c]);
			return b;
		}
		function J(a, b) {
			var c = C(a, b);
			return function (d) {
				var f = d.length,
					n;
				b.a && 3 === a.nodeType && a.nodeValue !== c.a && d.push(new p({ type: "characterData", target: a, oldValue: c.a }));
				b.b && c.b && A(d, a, c.b, b.f);
				if (b.c || b.g) n = K(d, a, c, b);
				if (n || d.length !== f) c = C(a, b);
			};
		}
		function L(a, b) {
			return b.value;
		}
		function M(a, b) {
			return "style" !== b.name ? b.value : a.style.cssText;
		}
		function A(a, b, c, d) {
			for (var f = {}, n = b.attributes, k, g, x = n.length; x--; ) (k = n[x]), (g = k.name), (d && d[g] === w) || (D(b, k) !== c[g] && a.push(p({ type: "attributes", target: b, attributeName: g, oldValue: c[g], attributeNamespace: k.namespaceURI })), (f[g] = !0));
			for (g in c) f[g] || a.push(p({ target: b, type: "attributes", attributeName: g, oldValue: c[g] }));
		}
		function K(a, b, c, d) {
			function f(b, c, f, k, y) {
				var g = b.length - 1;
				y = -~((g - y) / 2);
				for (var h, l, e; (e = b.pop()); ) (h = f[e.j]), (l = k[e.l]), d.c && y && Math.abs(e.j - e.l) >= g && (a.push(p({ type: "childList", target: c, addedNodes: [h], removedNodes: [h], nextSibling: h.nextSibling, previousSibling: h.previousSibling })), y--), d.b && l.b && A(a, h, l.b, d.f), d.a && 3 === h.nodeType && h.nodeValue !== l.a && a.push(p({ type: "characterData", target: h, oldValue: l.a })), d.g && n(h, l);
			}
			function n(b, c) {
				for (var g = b.childNodes, q = c.c, x = g.length, v = q ? q.length : 0, h, l, e, m, t, z = 0, u = 0, r = 0; u < x || r < v; ) (m = g[u]), (t = (e = q[r]) && e.node), m === t ? (d.b && e.b && A(a, m, e.b, d.f), d.a && e.a !== w && m.nodeValue !== e.a && a.push(p({ type: "characterData", target: m, oldValue: e.a })), l && f(l, b, g, q, z), d.g && (m.childNodes.length || (e.c && e.c.length)) && n(m, e), u++, r++) : ((k = !0), h || ((h = {}), (l = [])), m && (h[(e = E(m))] || ((h[e] = !0), -1 === (e = F(q, m, r, "node")) ? d.c && (a.push(p({ type: "childList", target: b, addedNodes: [m], nextSibling: m.nextSibling, previousSibling: m.previousSibling })), z++) : l.push({ j: u, l: e })), u++), t && t !== g[u] && (h[(e = E(t))] || ((h[e] = !0), -1 === (e = F(g, t, u)) ? d.c && (a.push(p({ type: "childList", target: c.node, removedNodes: [t], nextSibling: q[r + 1], previousSibling: q[r - 1] })), z--) : l.push({ j: e, l: r })), r++));
				l && f(l, b, g, q, z);
			}
			var k;
			n(b, c);
			return k;
		}
		function C(a, b) {
			var c = !0;
			return (function f(a) {
				var k = { node: a };
				!b.a || (3 !== a.nodeType && 8 !== a.nodeType)
					? (b.b &&
							c &&
							1 === a.nodeType &&
							(k.b = G(a.attributes, function (c, f) {
								if (!b.f || b.f[f.name]) c[f.name] = D(a, f);
								return c;
							})),
					  c && (b.c || b.a || (b.b && b.g)) && (k.c = N(a.childNodes, f)),
					  (c = b.g))
					: (k.a = a.nodeValue);
				return k;
			})(a);
		}
		function E(a) {
			try {
				return a.id || (a.mo_id = a.mo_id || H++);
			} catch (b) {
				try {
					return a.nodeValue;
				} catch (c) {
					return H++;
				}
			}
		}
		function N(a, b) {
			for (var c = [], d = 0; d < a.length; d++) c[d] = b(a[d], d, a);
			return c;
		}
		function G(a, b) {
			for (var c = {}, d = 0; d < a.length; d++) c = b(c, a[d], d, a);
			return c;
		}
		function F(a, b, c, d) {
			for (; c < a.length; c++) if ((d ? a[c][d] : a[c]) === b) return c;
			return -1;
		}
		v._period = 30;
		v.prototype = {
			observe: function (a, b) {
				for (var c = { b: !!(b.attributes || b.attributeFilter || b.attributeOldValue), c: !!b.childList, g: !!b.subtree, a: !(!b.characterData && !b.characterDataOldValue) }, d = this.i, f = 0; f < d.length; f++) d[f].s === a && d.splice(f, 1);
				b.attributeFilter &&
					(c.f = G(b.attributeFilter, function (a, b) {
						a[b] = !0;
						return a;
					}));
				d.push({ s: a, o: J(a, c) });
				this.h || I(this);
			},
			takeRecords: function () {
				for (var a = [], b = this.i, c = 0; c < b.length; c++) b[c].o(a);
				return a;
			},
			disconnect: function () {
				this.i = [];
				clearTimeout(this.h);
				this.h = null;
			},
		};
		var B = document.createElement("i");
		B.style.top = 0;
		var D = (B = "null" != B.attributes.style.value) ? L : M,
			H = 1;
		return v;
	})(void 0);
//forEach Polyfill
Array.prototype.forEach ||
	(Array.prototype.forEach = function (t, o) {
		if ("function" != typeof t) throw new TypeError(t + " is not a function");
		o = o || this;
		for (var r = 0, i = this.length; r !== i; ++r) t.call(o, this[r], r, this);
	});

!(function () {
	"use strict";
	if ("object" == typeof window)
		if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype)
			"isIntersecting" in window.IntersectionObserverEntry.prototype ||
				Object.defineProperty(window.IntersectionObserverEntry.prototype, "isIntersecting", {
					get: function () {
						return this.intersectionRatio > 0;
					},
				});
		else {
			var t = window.document,
				e = [];
			(o.prototype.THROTTLE_TIMEOUT = 100),
				(o.prototype.POLL_INTERVAL = null),
				(o.prototype.USE_MUTATION_OBSERVER = !0),
				(o.prototype.observe = function (t) {
					if (
						!this._observationTargets.some(function (e) {
							return e.element == t;
						})
					) {
						if (!t || 1 != t.nodeType) throw new Error("target must be an Element");
						this._registerInstance(), this._observationTargets.push({ element: t, entry: null }), this._monitorIntersections(), this._checkForIntersections();
					}
				}),
				(o.prototype.unobserve = function (t) {
					(this._observationTargets = this._observationTargets.filter(function (e) {
						return e.element != t;
					})),
						this._observationTargets.length || (this._unmonitorIntersections(), this._unregisterInstance());
				}),
				(o.prototype.disconnect = function () {
					(this._observationTargets = []), this._unmonitorIntersections(), this._unregisterInstance();
				}),
				(o.prototype.takeRecords = function () {
					var t = this._queuedEntries.slice();
					return (this._queuedEntries = []), t;
				}),
				(o.prototype._initThresholds = function (t) {
					var e = t || [0];
					return (
						Array.isArray(e) || (e = [e]),
						e.sort().filter(function (t, e, n) {
							if ("number" != typeof t || isNaN(t) || t < 0 || t > 1) throw new Error("threshold must be a number between 0 and 1 inclusively");
							return t !== n[e - 1];
						})
					);
				}),
				(o.prototype._parseRootMargin = function (t) {
					var e = (t || "0px").split(/\s+/).map(function (t) {
						var e = /^(-?\d*\.?\d+)(px|%)$/.exec(t);
						if (!e) throw new Error("rootMargin must be specified in pixels or percent");
						return { value: parseFloat(e[1]), unit: e[2] };
					});
					return (e[1] = e[1] || e[0]), (e[2] = e[2] || e[0]), (e[3] = e[3] || e[1]), e;
				}),
				(o.prototype._monitorIntersections = function () {
					this._monitoringIntersections || ((this._monitoringIntersections = !0), this.POLL_INTERVAL ? (this._monitoringInterval = setInterval(this._checkForIntersections, this.POLL_INTERVAL)) : (i(window, "resize", this._checkForIntersections, !0), i(t, "scroll", this._checkForIntersections, !0), this.USE_MUTATION_OBSERVER && "MutationObserver" in window && ((this._domObserver = new MutationObserver(this._checkForIntersections)), this._domObserver.observe(t, { attributes: !0, childList: !0, characterData: !0, subtree: !0 }))));
				}),
				(o.prototype._unmonitorIntersections = function () {
					this._monitoringIntersections && ((this._monitoringIntersections = !1), clearInterval(this._monitoringInterval), (this._monitoringInterval = null), r(window, "resize", this._checkForIntersections, !0), r(t, "scroll", this._checkForIntersections, !0), this._domObserver && (this._domObserver.disconnect(), (this._domObserver = null)));
				}),
				(o.prototype._checkForIntersections = function () {
					var t = this._rootIsInDom(),
						e = t ? this._getRootRect() : { top: 0, bottom: 0, left: 0, right: 0, width: 0, height: 0 };
					this._observationTargets.forEach(function (o) {
						var i = o.element,
							r = s(i),
							h = this._rootContainsTarget(i),
							c = o.entry,
							a = t && h && this._computeTargetAndRootIntersection(i, e),
							u = (o.entry = new n({ time: window.performance && performance.now && performance.now(), target: i, boundingClientRect: r, rootBounds: e, intersectionRect: a }));
						c ? (t && h ? this._hasCrossedThreshold(c, u) && this._queuedEntries.push(u) : c && c.isIntersecting && this._queuedEntries.push(u)) : this._queuedEntries.push(u);
					}, this),
						this._queuedEntries.length && this._callback(this.takeRecords(), this);
				}),
				(o.prototype._computeTargetAndRootIntersection = function (e, n) {
					if ("none" != window.getComputedStyle(e).display) {
						for (var o, i, r, h, a, u, d, l, p = s(e), f = c(e), g = !1; !g; ) {
							var _ = null,
								v = 1 == f.nodeType ? window.getComputedStyle(f) : {};
							if ("none" == v.display) return;
							if ((f == this.root || f == t ? ((g = !0), (_ = n)) : f != t.body && f != t.documentElement && "visible" != v.overflow && (_ = s(f)), _ && ((o = _), (i = p), (r = void 0), (h = void 0), (a = void 0), (u = void 0), (d = void 0), (l = void 0), (r = Math.max(o.top, i.top)), (h = Math.min(o.bottom, i.bottom)), (a = Math.max(o.left, i.left)), (u = Math.min(o.right, i.right)), (l = h - r), !(p = (d = u - a) >= 0 && l >= 0 && { top: r, bottom: h, left: a, right: u, width: d, height: l })))) break;
							f = c(f);
						}
						return p;
					}
				}),
				(o.prototype._getRootRect = function () {
					var e;
					if (this.root) e = s(this.root);
					else {
						var n = t.documentElement,
							o = t.body;
						e = { top: 0, left: 0, right: n.clientWidth || o.clientWidth, width: n.clientWidth || o.clientWidth, bottom: n.clientHeight || o.clientHeight, height: n.clientHeight || o.clientHeight };
					}
					return this._expandRectByRootMargin(e);
				}),
				(o.prototype._expandRectByRootMargin = function (t) {
					var e = this._rootMarginValues.map(function (e, n) {
							return "px" == e.unit ? e.value : (e.value * (n % 2 ? t.width : t.height)) / 100;
						}),
						n = { top: t.top - e[0], right: t.right + e[1], bottom: t.bottom + e[2], left: t.left - e[3] };
					return (n.width = n.right - n.left), (n.height = n.bottom - n.top), n;
				}),
				(o.prototype._hasCrossedThreshold = function (t, e) {
					var n = t && t.isIntersecting ? t.intersectionRatio || 0 : -1,
						o = e.isIntersecting ? e.intersectionRatio || 0 : -1;
					if (n !== o)
						for (var i = 0; i < this.thresholds.length; i++) {
							var r = this.thresholds[i];
							if (r == n || r == o || r < n != r < o) return !0;
						}
				}),
				(o.prototype._rootIsInDom = function () {
					return !this.root || h(t, this.root);
				}),
				(o.prototype._rootContainsTarget = function (e) {
					return h(this.root || t, e);
				}),
				(o.prototype._registerInstance = function () {
					e.indexOf(this) < 0 && e.push(this);
				}),
				(o.prototype._unregisterInstance = function () {
					var t = e.indexOf(this);
					-1 != t && e.splice(t, 1);
				}),
				(window.IntersectionObserver = o),
				(window.IntersectionObserverEntry = n);
		}
	function n(t) {
		(this.time = t.time), (this.target = t.target), (this.rootBounds = t.rootBounds), (this.boundingClientRect = t.boundingClientRect), (this.intersectionRect = t.intersectionRect || { top: 0, bottom: 0, left: 0, right: 0, width: 0, height: 0 }), (this.isIntersecting = !!t.intersectionRect);
		var e = this.boundingClientRect,
			n = e.width * e.height,
			o = this.intersectionRect,
			i = o.width * o.height;
		this.intersectionRatio = n ? Number((i / n).toFixed(4)) : this.isIntersecting ? 1 : 0;
	}
	function o(t, e) {
		var n,
			o,
			i,
			r = e || {};
		if ("function" != typeof t) throw new Error("callback must be a function");
		if (r.root && 1 != r.root.nodeType) throw new Error("root must be an Element");
		(this._checkForIntersections =
			((n = this._checkForIntersections.bind(this)),
			(o = this.THROTTLE_TIMEOUT),
			(i = null),
			function () {
				i ||
					(i = setTimeout(function () {
						n(), (i = null);
					}, o));
			})),
			(this._callback = t),
			(this._observationTargets = []),
			(this._queuedEntries = []),
			(this._rootMarginValues = this._parseRootMargin(r.rootMargin)),
			(this.thresholds = this._initThresholds(r.threshold)),
			(this.root = r.root || null),
			(this.rootMargin = this._rootMarginValues
				.map(function (t) {
					return t.value + t.unit;
				})
				.join(" "));
	}
	function i(t, e, n, o) {
		"function" == typeof t.addEventListener ? t.addEventListener(e, n, o || !1) : "function" == typeof t.attachEvent && t.attachEvent("on" + e, n);
	}
	function r(t, e, n, o) {
		"function" == typeof t.removeEventListener ? t.removeEventListener(e, n, o || !1) : "function" == typeof t.detatchEvent && t.detatchEvent("on" + e, n);
	}
	function s(t) {
		var e;
		try {
			e = t.getBoundingClientRect();
		} catch (t) {}
		return e ? ((e.width && e.height) || (e = { top: e.top, right: e.right, bottom: e.bottom, left: e.left, width: e.right - e.left, height: e.bottom - e.top }), e) : { top: 0, bottom: 0, left: 0, right: 0, width: 0, height: 0 };
	}
	function h(t, e) {
		for (var n = e; n; ) {
			if (n == t) return !0;
			n = c(n);
		}
		return !1;
	}
	function c(t) {
		var e = t.parentNode;
		return e && 11 == e.nodeType && e.host ? e.host : e && e.assignedSlot ? e.assignedSlot.parentNode : e;
	}
})();

var ssg = ssg || {};
ssg.Event = ssg.Event || {};
ssg.Event.emitter = {
	subscribers: {},
	on: function (s, t, i) {
		(this.subscribers[s] = this.subscribers[s] || []), this.subscribers[s].push({ callback: t, context: i });
	},
	off: function (s, t, i) {
		var r,
			c,
			e = this.subscribers[s];
		if (e)
			for (r = e.length - 1; r >= 0; ) {
				if (((c = e[r]), c.callback === t && (!i || c.context === i))) {
					e.splice(r, 1);
					break;
				}
				r--;
			}
	},
	emit: function (s) {
		var t,
			i = this.subscribers[s],
			r = 0,
			c = Array.prototype.slice.call(arguments, 1);
		if (i) for (; r < i.length; ) (t = i[r]), t.callback.apply(t.context || this, c), r++;
	},
};

ssg.View = ssg.View || {};
ssg.View.main = ssg.View.main || {};

ssg.View.main.heroSlider = function (htOptions) {
	$.extend(this, htOptions || {});
	this.init();
};

ssg.View.main.heroSlider.prototype = $.extend(
	{
		_htSlider: {
			auto: false,
			speed: 800,
			pause: 5000,
			controls: false,
			pager: false,
		},
		_sAutoState: "start",
		init: function () {
			this._assignElements();
			this._assignComponents();
		},
		_assignElements: function () {
			this._welHeroSlider = $("#_ssghero_slider");
			this._welHeroSliderList = this._welHeroSlider.find(".ssghero_slider_list");
			this._welHeroSliderCtrls = this._welHeroSlider.find(".cmmain_slider_ctrls");
			this._welSliderCtrlPrev = this._welHeroSliderCtrls.find(".slider_ctrl_prev");
			this._welSliderCtrlNext = this._welHeroSliderCtrls.find(".slider_ctrl_next");
			this._welSliderCtrlAuto = this._welHeroSliderCtrls.find(".slider_ctrl_auto");
			this._welSliderPageCurrent = this._welHeroSliderCtrls.find(".slider_page_current");
			this._welSliderPageTotal = this._welHeroSliderCtrls.find(".slider_page_total");
		},
		_assignComponents: function () {
			this._oHeroSlider = this._welHeroSliderList
				.filter(function () {
					return $(this).find(">li").length > 1;
				})
				.bxSlider(
					$.extend({}, this._htSlider, {
						onSliderLoad: $.proxy(this._onSliderLoad, this),
						onSlideBefore: $.proxy(this._onSlideBefore, this),
						onSlideAfter: $.proxy(this._onSlideAfter, this),
					})
				);
		},
		_findCurrentElement: function (index) {
			var slidePanels = this._welHeroSliderList.find(".ssghero_slide:not(.bx-clone)"),
					currentElem = $(slidePanels[index]);
			return currentElem;
		},
		_startSliderObserve: function () {
			var intersectionCallback = (entries) => {
				entries.forEach((entry) => {
					// console.log('entry', entry);
					// console.log('isIntersecting', entry.isIntersecting);
					if (entry.isIntersecting) {
						if (bFirstIntersecting) {
							bFirstIntersecting = false;
							var $slideElement = this._findCurrentElement(this._oHeroSlider.getCurrentSlide());
							$slideElement.trigger("enable.heroBanner");
						}
						this._isVisibleSlider = true;
						this.emit("inView");
					} else {
						this._isVisibleSlider = false;
						this.emit("outView");
					}
				});
			};

			const options = {
				root: null,
				threshold: 0,
			};
			var bFirstIntersecting = true;
			var observer = new IntersectionObserver(intersectionCallback, options);
			var target = document.querySelector(".cmmain_sec_slider");
			observer.observe(target);

			document.addEventListener(
				"visibilitychange",
				function () {
					if (!this._isVisibleSlider) {
						return;
					}

					if (document.hidden) {
						this.emit("outView");
					} else {
						this.emit("inView");
					}
				}.bind(this),
				false
			);
		},
		_initializeSlder: function () {
			var oSelf = this;
			var deferred = $.Deferred();
			var fnTimer = setInterval(function () {
				if (oSelf._oHeroSlider) {
					clearInterval(fnTimer);
					deferred.resolve();
				} else {
					deferred.notify();
				}
			}, 200);

			if (this._oHeroSlider) {
				clearInterval(fnTimer);
				deferred.resolve();
			}
			return deferred.promise();
		},
		_onSliderLoad: function () {
			this._initializeSlder().done(
				$.proxy(function () {
					this._welHeroSlider.off("mouseenter.heroslider").on("mouseenter.heroslider", $.proxy(this._onMouseenterSliderStop, this));
					this._welHeroSlider.off("mouseleave.heroslider").on("mouseleave.heroslider", $.proxy(this._onMouseleaveSliderStart, this));

					this._welSliderCtrlPrev.off("click.heroslider").on("click.heroslider", $.proxy(this._onClickMovePrev, this));
					this._welSliderCtrlNext.off("click.heroslider").on("click.heroslider", $.proxy(this._onClickMoveNext, this));
					this._welSliderCtrlAuto.off("click.heroslider").on("click.heroslider", $.proxy(this._onClickCtrlAuto, this));

					var currentIndex = this._oHeroSlider.getCurrentSlide() + 1;
					var totalIndex = this._oHeroSlider.getSlideCount();
					this._welSliderPageCurrent.html(currentIndex);
					this._welSliderPageTotal.html(totalIndex);
					//this._welHeroSliderList.children().eq(currentIndex).addClass('active_slide');

					this._startSliderObserve();
				}, this)
			);
		},
		_onSlideBefore: function ($slideElement, oldIndex, newIndex) {
			this._updateSlidePageIndex(newIndex);
			$slideElement.trigger("enable.heroBanner");
		},
		_onSlideAfter: function ($slideElement, oldIndex, newIndex) {
			// this._welHeroSliderList.children().removeClass('active_slide');
			// $slideElement.addClass('active_slide');
		},
		_onMouseenterSliderStop: function () {
			if (this._sAutoState === "stop") {
				return;
			}
			this._oHeroSlider.stopAuto();
		},
		_onMouseleaveSliderStart: function () {
			if (this._sAutoState === "stop") {
				return;
			}
			this._oHeroSlider.startAuto();
		},
		_onClickMovePrev: function () {
			this._stopAuto();
			this._oHeroSlider.goToPrevSlide();
		},
		_onClickMoveNext: function () {
			this._stopAuto();
			this._oHeroSlider.goToNextSlide();
		},
		_onClickCtrlAuto: function (e) {
			var welTarget = $(e.currentTarget);
			if (welTarget.hasClass("autoplay")) {
				this._stopAuto();
			} else {
				this._startAuto();
			}
		},
		_updateSlidePageIndex: function (nCurrent) {
			this._welSliderPageCurrent.html(nCurrent + 1);
		},
		_changeAutoState: function (sAutoState) {
			this._sAutoState = sAutoState;

			if (sAutoState === "start") {
				this._welSliderCtrlAuto.addClass("autoplay");
			} else if (sAutoState === "stop") {
				this._welSliderCtrlAuto.removeClass("autoplay");
			}
		},
		_startAuto: function () {
			this._changeAutoState("start");
			this._oHeroSlider.startAuto();
		},
		_stopAuto: function () {
			this._changeAutoState("stop");
			this._oHeroSlider.stopAuto();
		},
		reloadSlider: function () {
			this._oHeroSlider.reloadSlider();
		},
	},
	ssg.Event.emitter
);

ssg.View.main.promSlider = function (htOptions) {
	$.extend(this, htOptions || {});
	this.init();
};

ssg.View.main.promSlider.prototype = $.extend(
	{
		_htSlider: {
			auto: false,
			speed: 1,
			pause: 5000,
			maxSlides: 6,
			moveSlides: 6,
			slideWidth: 180,
			slideMargin: 40,
			controls: false,
			pager: false,
		},
		_sAutoState: "start",
		init: function () {
			this._assignElements();
			this._assignComponents();
		},
		_assignElements: function () {
			this._welPromSlider = $("#_ssgprom_slider");
			this._welPromSliderList = this._welPromSlider.find(".ssgprom_slider_list");
			this._welPromSliderCtrls = this._welPromSlider.find(".cmmain_slider_ctrls");
			this._welSliderCtrlPrev = this._welPromSliderCtrls.find(".slider_ctrl_prev");
			this._welSliderCtrlNext = this._welPromSliderCtrls.find(".slider_ctrl_next");
			this._welSliderCtrlAuto = this._welPromSliderCtrls.find(".slider_ctrl_auto");
			this._welSliderPageCurrent = this._welPromSliderCtrls.find(".slider_page_current");
			this._welSliderPageTotal = this._welPromSliderCtrls.find(".slider_page_total");
		},
		_assignComponents: function () {
			this._welPromSliderList.find(">li").find("img").attr("loading", "auto");

			this._oPromSlider = this._welPromSliderList
				.filter(function () {
					return $(this).find(">li").length > 6;
				})
				.bxSlider(
					$.extend({}, this._htSlider, {
						onSliderLoad: $.proxy(this._onSliderLoad, this),
						onSlideBefore: $.proxy(this._onSlideBefore, this),
					})
				);
		},
		_initializeSlder: function () {
			var oSelf = this;
			var deferred = $.Deferred();
			var fnTimer = setInterval(function () {
				if (oSelf._oPromSlider) {
					clearInterval(fnTimer);
					deferred.resolve();
				} else {
					deferred.notify();
				}
			}, 200);

			if (this._oPromSlider) {
				clearInterval(fnTimer);
				deferred.resolve();
			}
			return deferred.promise();
		},
		_onSliderLoad: function () {
			this._initializeSlder().done(
				$.proxy(function () {
					this._welPromSlider.off("mouseenter.promslider").on("mouseenter.promslider", $.proxy(this._onMouseenterSliderStop, this));
					this._welPromSlider.off("mouseleave.promslider").on("mouseleave.promslider", $.proxy(this._onMouseleaveSliderStart, this));

					this._welSliderCtrlPrev.off("click.promslider").on("click.promslider", $.proxy(this._onClickMovePrev, this));
					this._welSliderCtrlNext.off("click.promslider").on("click.promslider", $.proxy(this._onClickMoveNext, this));
					this._welSliderCtrlAuto.off("click.promslider").on("click.promslider", $.proxy(this._onClickCtrlAuto, this));

					var currentIndex = this._oPromSlider.getCurrentSlide() + 1;
					var totalIndex = Math.ceil(this._oPromSlider.getSlideCount() / this._htSlider.moveSlides);

					this._welSliderPageCurrent.html(currentIndex);
					this._welSliderPageTotal.html(totalIndex);
				}, this)
			);
		},
		_onSlideBefore: function (slideElement, oldIndex, newIndex) {
			this._updateSlidePageIndex(newIndex);
		},
		_onMouseenterSliderStop: function () {
			if (this._sAutoState === "stop") {
				return;
			}
			this._oPromSlider.stopAuto();
		},
		_onMouseleaveSliderStart: function () {
			if (this._sAutoState === "stop") {
				return;
			}
			this._oPromSlider.startAuto();
		},
		_onClickMovePrev: function () {
			this._stopAuto();
			this._oPromSlider.goToPrevSlide();
		},
		_onClickMoveNext: function () {
			this._stopAuto();
			this._oPromSlider.goToNextSlide();
		},
		_onClickCtrlAuto: function (e) {
			var welTarget = $(e.currentTarget);
			if (welTarget.hasClass("autoplay")) {
				this._stopAuto();
			} else {
				this._startAuto();
			}
		},
		_updateSlidePageIndex: function (nCurrent) {
			this._welSliderPageCurrent.html(nCurrent + 1);
		},
		_changeAutoState: function (sAutoState) {
			this._sAutoState = sAutoState;

			if (sAutoState === "start") {
				this._welSliderCtrlAuto.addClass("autoplay");
			} else if (sAutoState === "stop") {
				this._welSliderCtrlAuto.removeClass("autoplay");
			}
		},
		_startAuto: function () {
			this._changeAutoState("start");
			this._oPromSlider.startAuto();
		},
		_stopAuto: function () {
			this._changeAutoState("stop");
			this._oPromSlider.stopAuto();
		},
		reloadSlider: function () {
			this._oPromSlider.reloadSlider();
		},
	},
	ssg.Event.emitter
);

ssg.View.main.scrollBottom = function (htOptions) {
	$.extend(this, htOptions || {});
	this.init();
};
ssg.View.main.scrollBottom.prototype = $.extend(
	{
		isEnd: false,
		init() {
			this._assignElements();
			this._attachEventHandlers();
		},
		_assignElements() {
			this._welFooter = document.querySelector(".ssgmain_sitemap");
		},
		_attachEventHandlers() {
			var previousY = 0;
			var previousRatio = 0;
			var options = {
				root: null,
				rootMargin: "0px",
				threshold: [0, 0.3, 0.5, 0.8, 1],
			};

			const scrollToBottom = (entries, observer) => {
				entries.forEach((entry) => {
					const isIntersecting = entry.isIntersecting;

					if (isIntersecting) {
						if (this.isEnd) {
							io.unobserve(this._welFooter);
							return;
						}
						this.emit("scrollbottom");
					}
				});
			};

			/*
		var scrollToBottom = (entries, observer) => {
			entries.forEach(entry => {
			  const currentY = entry.boundingClientRect.y
			  const currentRatio = entry.intersectionRatio
			  const isIntersecting = entry.isIntersecting

			  // Scrolling down/up
			  if (currentY < previousY) {
			    if (currentRatio > previousRatio && isIntersecting) {
						this.emit('scrollbottom');
			      //console.log("Scrolling down enter")
			    } else {
			      console.log("Scrolling down leave");
			    }
			  } else if (currentY > previousY && isIntersecting) {
			    if (currentRatio < previousRatio) {
			      console.log("Scrolling up leave")
			    } else {
						this.emit('scrollbottom');
			      //console.log("Scrolling up enter")
			    }
			  }

			  previousY = currentY;
			  previousRatio = currentRatio;
			})

			// const currentY = entries[0].boundingClientRect.y;
			// const currentRatio = entries[0].intersectionRatio;
			// const isIntersecting = entries[0].isIntersecting;

			// if (currentY < previousY) {
			// 	if (currentRatio > previousRatio && isIntersecting) {
			// 		if (this.isEnd) {
			// 			io.unobserve(this._welFooter);
			// 			return;
			// 		}
			// 		this.emit('scrollbottom');
			// 	}
			// }
			// previousY = currentY;
			// previousRatio = currentRatio;
		};
		*/

			var io = new IntersectionObserver(scrollToBottom, options);
			io.observe(this._welFooter);
		},
	},
	ssg.Event.emitter
);

ssg.View.main.tabMenu = function (htOptions) {
	$.extend(this, htOptions || {});
	this.init();
};
ssg.View.main.tabMenu.prototype = $.extend(
	{
		init: function () {
			this._assignElements();
			this._attachEventHandlers();

			$(".cmmain_cmplan_slider")
				.filter(function () {
					return $(this).find(">.cmplan_unit").length > 1;
				})
				.bxSlider({
					pager: true,
					pagerType: "short",
					controls: true,
				});
		},
		_assignElements: function () {
			this._welBody = $("body");
		},
		_attachEventHandlers: function () {
			this._welBody.on("click", ".js_cmmain_tab", $.proxy(this._onClickTabmenu, this));
		},
		_onClickTabmenu: function (e) {
			e.preventDefault();

			var welTarget = $(e.currentTarget);
			var welTabWrap = welTarget.closest(".js_cmmain_tabwrap");
			var welTabList = welTarget.parent();
			var welTabPanel = welTabWrap.find(".js_cmmain_tabpanel");
			var welActivePanel = welTabPanel.eq(welTabList.index());

			var isLoadingData = welActivePanel.hasClass("js_loading_data");
			var sEventNamespace = "clickTabmenu." + welTabWrap.data("tabname");

			if (welTabList.hasClass("on")) {
				return;
			}

			welTabList.addClass("on").siblings().removeClass("on");
			welTabList.siblings().find(".js_cmmain_tab").attr("aria-selected", "false");
			welTarget.attr("aria-selected", "true");
			welActivePanel.addClass("on").siblings().removeClass("on");

			if (isLoadingData) {
				this.emit(sEventNamespace, welTarget, welActivePanel);
			}
		},
	},
	ssg.Event.emitter
);

ssg.View.main.ranking = function (htOptions) {
	$.extend(this, htOptions || {});
	this.init();
};
ssg.View.main.ranking.prototype = $.extend(
	{
		init: function () {
			this._assignElements();
			this._attachEventHandlers();
		},
		_assignElements: function () {
			this._welBody = $("body");
			this._welRanking = $(".cmmain_rank_tabwrap");
		},
		_attachEventHandlers: function () {
			this._welRanking.on("click", ".cmmain_rank_tab", $.proxy(this._onClickTabmenu, this));
		},
		_onClickTabmenu: function (e) {
			e.preventDefault();

			var welTarget = $(e.currentTarget);
			var welTabWrap = welTarget.closest(".cmmain_rank_tabwrap");
			var welTabList = welTarget.parent();
			var welTabPanel = welTabWrap.find(".cmmain_rank_tabpanel");
			var nTabIndex = welTabList.index();
			var welActivePanel = welTabPanel.eq(nTabIndex);

			if (welTabList.hasClass("on")) {
				return;
			}
			welTabList.addClass("on").siblings().removeClass("on");
			welTabList.siblings().find(".cmmain_rank_tab").attr("aria-selected", "false");
			welTarget.attr("aria-selected", "true");
			welActivePanel.addClass("on").siblings().removeClass("on");
			welActivePanel.find(".rank_list > li").removeClass("on").eq(0).addClass("on");
		},
	},
	ssg.Event.emitter
);

ssg.View.main.ssgdaySlider = function (htOptions) {
	$.extend(this, htOptions || {});
	this.init();
};
ssg.View.main.ssgdaySlider.prototype = $.extend(
	{
		_htSlider: {
			mode: "horizontal",
			speed: 1000,
			pause: 500,
			auto: false,
			infiniteLoop: false,
			controls: false,
			pager: false,
			hideControlOnEnd: true,
		},
		init: function init() {
			this._assignElements();
			this._assignComponents();
		},
		_assignElements: function _assignElements() {
			this._welTarget = $("#_ssgday_brand_slider");
			this._welSsgdayList = this._welTarget.find(".ssgday_brand_lst");
			this._welSsgdayCtrl = this._welTarget.find(".ssgday_brand_ctrl");
			this._welSsgdayCtrlPrev = this._welSsgdayCtrl.find(".ssgday_brand_prev");
			this._welSsgdayCtrlNext = this._welSsgdayCtrl.find(".ssgday_brand_next");
			this._welSsgdayOptions = {
				minSlides: this.sMinSlides,
				maxSlides: this.sMaxSlides,
				moveSlides: this.sMoveSlides,
				slideMargin: this.slideMargin,
				slideWidth: this.slideWidth,
			};
		},
		_assignComponents: function _assignComponents() {
			this._oSsgdaySlider = this._welSsgdayList
				.filter(function () {
					return $(this).find(">li").length > 0;
				})
				.bxSlider(
					$.extend({}, this._htSlider, this._welSsgdayOptions, {
						onSliderLoad: $.proxy(this._onSliderLoad, this),
						onSlideAfter: $.proxy(this._onSlideAfter, this),
					})
				);
		},
		_initializeSlder: function _initializeSlder() {
			var t = this,
				i = $.Deferred(),
				e = setInterval(function () {
					if (t._oSsgdaySlider) {
						clearInterval(e);
						i.resolve();
					} else {
						i.notify();
					}
				}, 200);
			if (this._oSsgdaySlider) {
				clearInterval(e);
				i.resolve();
			}
			return i.promise();
		},
		_onSliderLoad: function _onSliderLoad() {
			this._initializeSlder().done(
				$.proxy(function () {
					this._welSsgdayCtrlPrev.off("click.mainslider").on("click.mainslider", $.proxy(this._onClickMovePrev, this));
					this._welSsgdayCtrlNext.off("click.mainslider").on("click.mainslider", $.proxy(this._onClickMoveNext, this));
				}, this)
			);
		},
		_onSlideAfter: function onSlideAfter() {
			this._welSsgdayCtrl.find("button").removeClass("disabled");
			if (this._oSsgdaySlider.getCurrentSlide() == 0) {
				this._welSsgdayCtrlPrev.addClass("disabled");
			} else if (this._oSsgdaySlider.getCurrentSlide() == Math.floor(this._oSsgdaySlider.getSlideCount() / 10)) {
				this._welSsgdayCtrlNext.addClass("disabled");
			}
		},
		_onClickMovePrev: function _onClickMovePrev() {
			this._stopAuto();
			this._oSsgdaySlider.goToPrevSlide();
		},
		_onClickMoveNext: function _onClickMoveNext() {
			this._stopAuto();
			this._oSsgdaySlider.goToNextSlide();
		},
		_startAuto: function _startAuto() {
			this._oSsgdaySlider.startAuto();
		},
		_stopAuto: function _stopAuto() {
			this._oSsgdaySlider.stopAuto();
		},
	},
	ssg.Event.emitter
);

ssg.View.main.mmbrsSlider = ssg.View.main.mmbrsSlider || {};
ssg.View.main.mmbrsSlider.prototype = $.extend(
	{
		wrapper: null,
		button: null,
		slideList: null,
		slideItem: null,
		index: 0,
		shift: 1,
		visible: 1,
	},
	{
		init() {
			this._initVar();
			this._setOptions();
			this._assignElements();
			this._assignComponents();
			this._handleController();
		},
		_initVar() {
			this.itemWidth = 0;
			this.listSum = 0;
			this.listArray = [0];
		},
		_assignElements() {
			this._welSlideWrap = document.querySelector(this.wrapper);
			this._welSlideList = this._welSlideWrap.querySelector(this.slideList);
			this._welSlideItems = this._welSlideWrap.querySelectorAll(this.slideItem);
			this._welSlideItem = this._welSlideWrap.querySelector(this.slideItem);
			this._welSlideButton = this._welSlideWrap.querySelectorAll(this.button);
			this._welSlidePrev = this._welSlideWrap.querySelector(`.js-prev`);
			this._welSlideNext = this._welSlideWrap.querySelector(`.js-next`);
		},
		_setOptions() {
			this._welSlideButton = this.button != undefined && this.button !== null ? this.button : 0;
			this._welSlideIndex = this.index != undefined && this.index !== null ? this.index : null;
			this._welSlideVisible = this.visible != undefined && this.visible !== null ? this.visible : 1;
			this._welSlideShift = this.shift != undefined && this.shift !== null ? this.shift : 1;
		},
		updateSlider() {
			this._initVar();
			this._assignElements();
		},
		_assignComponents() {
			this._initialize();
			this._attachEventHandlers();
		},
		_attachEventHandlers() {
			if (this._welSlideButton !== null) {
				let throttlingSlide = null;
				Array.from(this._welSlideButton).forEach((button) => {
					button.addEventListener(`click`, (event) => {
						if (!throttlingSlide) {
							throttlingSlide = setTimeout(() => {
								this._onBtnClick(event);
								throttlingSlide = null;
							}, 350);
						}
					});
				});
			}
		},
		_initialize() {
			this._initList();
		},
		_initList() {
			let offsetsXSum = 0;
			this.listLen = this._welSlideItems.length;

			Array.from(this._welSlideItems).forEach((item, index) => {
				const itemWidth = parseInt(item.getBoundingClientRect().width);
				item.style.width = `${itemWidth}px`;

				offsetsXSum += itemWidth + parseInt(getComputedStyle(item).marginRight);
				this.listArray.push(offsetsXSum);

				if ((index >= this._welSlideIndex && index < this._welSlideIndex + this._welSlideVisible) || (index >= this.listLen - this._welSlideVisible && Math.floor(this._welSlideIndex / this._welSlideVisible) === Math.floor(this.listLen / this._welSlideVisible))) {
					item.classList.add(`active`);
					item.setAttribute("aria-hidden", "false");
					item.removeAttribute("tabindex");
				} else {
					item.classList.remove(`active`);
					item.setAttribute("aria-hidden", "true");
					item.setAttribute("tabindex", "-1");
				}
			});

			this._welSlideList.style.width = `${offsetsXSum}px`;
		},
		_viewUpdater() {
			this._initList();
			this._viewIndex();
		},
		_onBtnClick(event) {
			let eventTarget = event.target.closest(this.button);

			this.listLen = this._welSlideItems.length;

			if (eventTarget.classList.contains(`js-prev`)) {
				this._welSlideIndex = this._welSlideIndex - this._welSlideShift < 0 ? 0 : this._welSlideIndex - this._welSlideShift;
			} else if (eventTarget.classList.contains(`js-next`)) {
				this._welSlideIndex = this._welSlideIndex + this._welSlideShift > this.listLen - 1 ? this._welSlideIndex : this._welSlideIndex + this._welSlideShift;
			}

			this._handleController();
			this._viewUpdater();
		},
		_handleController() {
			if (this._welSlideIndex === 0) {
				this._welSlidePrev.classList.add("disabled");
				this._welSlidePrev.setAttribute("tabindex", "-1");
			} else {
				this._welSlidePrev.classList.remove("disabled");
				this._welSlidePrev.removeAttribute("tabindex");
			}

			if (Math.floor(this._welSlideIndex / this._welSlideVisible) === Math.floor((this.listLen - 1) / this._welSlideVisible)) {
				this._welSlideNext.classList.add("disabled");
				this._welSlideNext.setAttribute("tabindex", "-1");
			} else {
				this._welSlideNext.classList.remove("disabled");
				this._welSlideNext.removeAttribute("tabindex");
			}
			if (this.listLen > 4) {
				this._welSlidePrev.style.display = "block";
				this._welSlideNext.style.display = "block";
			}
		},
		_viewIndex() {
			this.listLen = this._welSlideItems.length;
			const item = this._welSlideItem;
			const itemWidth = parseInt(item.getBoundingClientRect().width);
			const restItem = (this.listLen - this._welSlideIndex - this._welSlideVisible) * (itemWidth + parseInt(getComputedStyle(item).marginRight));

			// 보이는 아이템이  4개가 아닐 때
			if (this.listLen - this._welSlideIndex - this._welSlideVisible < 0) {
				this._welSlideList.style.transform = `translate(${-this.listArray[this._welSlideIndex] - restItem}px, 0)`;
				this._welSlideList.style.transition = `all .3s`;
			} else {
				// 보이는 아이템이  4개 일때
				this._welSlideList.style.transform = `translate(${-this.listArray[this._welSlideIndex]}px, 0)`;
				this._welSlideList.style.transition = `all .3s`;
			}

			// 마지막 바로 전 슬라이드에서 데이터 추가 호출
			if (Math.floor(this._welSlideIndex / this._welSlideVisible) === Math.floor(this.listLen / this._welSlideVisible - 2)) {
				this.emit("smileClubSlider.dataUpdate");
			}

			setTimeout(() => {
				Array.from(this._welSlideItems).forEach((item) => {
					item.style.transition = ``;
				});
			}, 350);
		},
	},
	ssg.Event.emitter
);
ssg.View.main.smileClubSlider = function (options) {
	const sliderOptions = {
		wrapper: `.common_mmbrs_sliderwrap`,
		slideList: `.cunit_thmb_lst`,
		slideItem: `.cunit_thmb_lst > li`,
		button: `.common_mmbrs_slider_button`,
		index: 0,
		shift: 4,
		visible: 4,
	};
	$.extend(this, sliderOptions, options || {});
	this.init();
};
ssg.View.main.smileClubSlider.prototype = ssg.View.main.mmbrsSlider.prototype;
// $(window).on('load', function() {

// });

$(function () {
	var oSsgMainHeroSlider = new ssg.View.main.heroSlider();
	var oSsgMainPromSlider = new ssg.View.main.promSlider();
	var oSsgMainScroll = new ssg.View.main.scrollBottom();
	var oSsgViewMainRanking = new ssg.View.main.ranking();

	// oSsgMainScroll.on('scrollbottom', function(){
	//   console.log('bottom');
	// });

	oSsgMainHeroSlider.on("inView", function () {
		//console.log('슬라이더 재생');
		oSsgMainHeroSlider._startAuto();
		oSsgMainPromSlider._startAuto();
	});

	oSsgMainHeroSlider.on("outView", function () {
		//console.log('슬라이더 정지');
		oSsgMainHeroSlider._stopAuto();
		oSsgMainPromSlider._stopAuto();
	});

	$(".cmmain_event_slider")
		.filter(function () {
			return $(this).find(">li").length > 1;
		})
		.bxSlider({
			//auto: true,
			pager: true,
			pagerType: "short",
			controls: true,
			adaptiveHeight: true,
		});

	//타임딜 타이머
	$(".js_timedeal_timer").each(function () {
		var welTarget = $(this);
		welTarget.timerManager({
			startDate: new Date(),
			endDate: new Date(welTarget.data("endDate")),
			callback: function () {
				var currentTime = this.getCurrentTimerTime();
				var welTimer = this.getTargetContainer();
				var nDay = parseInt(currentTime.day, 10);

				if (nDay > 0) {
					welTimer.find(".mndmoon_time").html('<span class="blind">타임딜 남은시간</span><span class="day">D-' + nDay + "</span>");
					this.stop();
				} else {
					welTimer.find(".hour").text(currentTime.hour);
					welTimer.find(".min").text(currentTime.min);
					welTimer.find(".sec").text(currentTime.sec);
				}
			},
		});
	});

	//체험혜택 타이머
	$(".js_sample_timer").each(function () {
		var welTarget = $(this);
		welTarget.timerManager({
			startDate: new Date(),
			endDate: new Date(welTarget.data("endDate")),
			callback: function () {
				var currentTime = this.getCurrentTimerTime();
				var welTimer = this.getTargetContainer();
				var nDay = parseInt(currentTime.day, 10);

				if (nDay > 0) {
					welTimer.find(".day").text("D-" + nDay);
				} else {
					welTimer.find(".day").hide();
				}

				welTimer.find(".hour").text(currentTime.hour);
				welTimer.find(".min").text(currentTime.min);
				welTimer.find(".sec").text(currentTime.sec);
			},
		});
	});

	$(".cmmain_cunit_slider>ul")
		.filter(function () {
			return $(this).find(">li").length > 1;
		})
		.bxSlider({
			infiniteLoop: false,
			hideControlOnEnd: true,
			adaptiveHeight: true,
			responsive: false,
			pager: false,
			prevText: '<span class="blind">이전 목록보기</span>',
			nextText: '<span class="blind">다음 목록보기</span>',
			onSliderLoad: function () {
				$(".cmmain_cunit_slider .bx-controls-direction a").prop("tabIndex", "-1");
				$(".cmmain_cunit_slider>ul>li").prop("tabIndex", "-1");
			},
		});

		// 쓱데이 명예의 전당, 쓱데이 브랜드 퍼레이드
		$(".cmmain_cunit_slider_with_tracking>ul")
		.filter(function () {
			return $(this).find(">li").length > 1;
		})
		.bxSlider({
			infiniteLoop: false,
			hideControlOnEnd: true,
			adaptiveHeight: true,
			responsive: false,
			pager: false,
			prevText: '<span class="blind">이전 목록보기</span>',
			nextText: '<span class="blind">다음 목록보기</span>',
			onSliderLoad: function () {
				$(".cmmain_cunit_slider_with_tracking .bx-controls-direction a").prop("tabIndex", "-1");
				$(".cmmain_cunit_slider_with_tracking .bx-controls-direction a").attr("data-react-tarea-dtl-cd", "t00060");
				$(".cmmain_cunit_slider_with_tracking>ul>li").prop("tabIndex", "-1");
			},
		});
});
